document.addEventListener('DOMContentLoaded', function() {
  // Nav scroll
  var nav = document.getElementById('cb-navbar');
  if (nav) {
    window.addEventListener('scroll', function() {
      nav.classList.toggle('scrolled', window.scrollY > 60);
    });
  }

  // Scroll reveal — respects prefers-reduced-motion
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var els = document.querySelectorAll('.cb-reveal');
  if (els.length && !prefersReducedMotion) {
    var obs = new IntersectionObserver(function(e) {
      e.forEach(function(x) {
        if (x.isIntersecting) x.target.classList.add('visible');
      });
    }, { threshold: 0.12 });
    els.forEach(function(el) { obs.observe(el); });
  } else {
    // If reduced motion, show everything immediately
    els.forEach(function(el) { el.classList.add('visible'); });
  }

  // Mobile menu — accessible open/close with focus trap
  var openBtn = document.querySelector('.cb-header__ham');
  var menu = document.getElementById('cb-mobile-menu');
  var closeBtn = menu ? menu.querySelector('.cb-header__mobile-close') : null;

  function openMobileMenu() {
    if (!menu) return;
    menu.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (closeBtn) closeBtn.focus();
  }

  function closeMobileMenu() {
    if (!menu) return;
    menu.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (openBtn) openBtn.focus();
  }

  if (openBtn) openBtn.addEventListener('click', openMobileMenu);
  if (closeBtn) closeBtn.addEventListener('click', closeMobileMenu);

  // Close on Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && menu && menu.getAttribute('aria-hidden') === 'false') {
      closeMobileMenu();
    }
  });

  // Close when clicking a link in mobile menu
  if (menu) {
    menu.querySelectorAll('a').forEach(function(a) {
      a.addEventListener('click', closeMobileMenu);
    });
  }

  // Focus trap inside mobile menu
  if (menu) {
    menu.addEventListener('keydown', function(e) {
      if (e.key !== 'Tab') return;
      var focusable = menu.querySelectorAll('a, button, [tabindex]:not([tabindex="-1"])');
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }
});
